'use client';
import { Option } from 'effect';
import { useEffect } from 'react';

import {
  accessoriesLoadMorePagesAtom,
  accessoriesTaxonSearchParamAtom,
} from '../../../effect/atom/products/recommendationsPagination';
import { getAccessoriesTaxonFromHistoryState } from '../../../effect/utils/history/productAccessoriesHistoryStateManager';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  productCode: string;
};

export default function AccessoriesFilterUrlInitializer({ productCode }: Props) {
  const setAccessoriesTaxon = useAtomSet(accessoriesTaxonSearchParamAtom);
  const setLoadMorePages = useAtomSet(accessoriesLoadMorePagesAtom, { mode: 'value' });

  useEffect(() => {
    const savedTaxonOption = getAccessoriesTaxonFromHistoryState(productCode);

    if (Option.isSome(savedTaxonOption)) {
      const taxonCode = savedTaxonOption.value;

      setAccessoriesTaxon(taxonCode === null ? Option.none() : Option.some(taxonCode));
      setLoadMorePages(0);
    }
  }, [productCode, setAccessoriesTaxon, setLoadMorePages]);

  useEffect(() => {
    const handlePopState = () => {
      const savedTaxonOption = getAccessoriesTaxonFromHistoryState(productCode);

      const taxonCode = Option.getOrElse(savedTaxonOption, () => null);

      setAccessoriesTaxon(taxonCode === null ? Option.none() : Option.some(taxonCode));
      setLoadMorePages(0);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [productCode, setAccessoriesTaxon, setLoadMorePages]);

  return null;
}
